import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  class: "ml-3 relative flex-shrink-0",
  ref: "userMenu"
}
const _hoisted_2 = { class: "relative w-8 h-8 overflow-hidden bg-gray-100 rounded-full dark:bg-gray-600" }
const _hoisted_3 = {
  key: 0,
  class: "absolute w-10 h-10 text-gray-400 -left-1",
  fill: "currentColor",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 0,
  class: "origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg pt-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none z-50",
  role: "menu",
  "aria-orientation": "vertical",
  "aria-labelledby": "user-menu-button",
  tabindex: "-1"
}
const _hoisted_7 = { class: "border-t py-2 px-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_logout_button = _resolveComponent("logout-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("button", {
        type: "button",
        class: _normalizeClass(["bg-sky rounded-full flex text-sm text-white focus:outline-none", { 'pointer-events-none': _ctx.userHasRole(_ctx.RoleType.BROKER) }]),
        "aria-expanded": "false",
        "aria-haspopup": "true",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.userMenuToggled = !_ctx.userMenuToggled))
      }, [
        _createElementVNode("div", _hoisted_2, [
          (!_ctx.userProfile.picture)
            ? (_openBlock(), _createElementBlock("svg", _hoisted_3, _hoisted_5))
            : (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "absolute w-8 h-8 left-0 bg-cover bg-center",
                style: _normalizeStyle({
              'background-image': `url(${_ctx.userProfile.picture})`
            })
              }, null, 4))
        ])
      ], 2)
    ]),
    (_ctx.userMenuToggled && !_ctx.userHasRole(_ctx.RoleType.BROKER))
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nav, ({ key, label, path }) => {
            return (_openBlock(), _createBlock(_component_router_link, {
              key: key,
              to: path,
              class: "block py-2 px-4 text-sm text-gray-700 hover:text-indigo-700",
              "active-class": "bg-gray-100"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(label), 1)
              ]),
              _: 2
            }, 1032, ["to"]))
          }), 128)),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_logout_button)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 512))
}